<script lang="ts">
	//Formatters
	import { format } from 'src/services/i18n';
	//Design system components
	import { Alert } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Stores
	import { navigateToSetting } from 'src/stores/ui/navigate-to';
	import { compareFWVersions } from 'src/helpers/firmware_compare_helpers';
	import { isBluTRV, isBluTRVGateway } from 'src/helpers/interface_helpers';

	export let device: Device;
	export let values: { minVersion: string; fwVersion: string };
	export let isOffline = false;

	$: headingValues = {
		fwVersion:
			values?.fwVersion &&
			compareFWVersions(values?.fwVersion.match(/\d+(\.\d+){2,}/gi)?.toString(), '>', '1.0.0')
				? values?.fwVersion
				: $format('data_not_loaded', { default: `Couldn't load data` }),
		minVersion: values?.minVersion,
	};

	$: heading = $format('warn_subsetting_unsupported_firmware', {
		values: headingValues,
		default: 'Unsupported firmware version - {fwVersion}. Please update your device.',
	});

	if (isBluTRVGateway(device?.type) || isBluTRV(device?.type)) {
		heading = $format('warn_subsetting_unsupported_firmware_trv', {
			values,
			default: 'New firmware version available. Please update now. It may take up to 2 minutes.',
		});
	}
</script>

<Alert
	type="warning"
	{heading}
	cta={{
		title: isOffline
			? ''
			: capFirstChar(
					$format('sub_settings_title_firmware_update', {
						default: 'Firmware upgrade',
					}),
				),
	}}
	on:cta_click={() => navigateToSetting(device.id, 'settings', 'firmware_version')}
/>
